let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gZzWH")).then(() => parcelRequire('gQhS1'));